<template>
    <mtd-cascader
        v-model="innerValue"
        class="cascader"
        :data="sgCategoryList"
        placeholder="请选择品类"
        filterable
        :props="{
            label:'label',
            value:'id',
            children:'children'
        }"
        :disabled="disabled"
        @change="handleChange"
    />
</template>

<script setup>
import { ref, computed, getCurrentInstance } from '@vue/composition-api';
import { hPost } from '@mcfe/tools';

export default {
    name: 'SgCategorySelect',

    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        const { proxy, props } = getCurrentInstance();
        const sgCategoryList = ref([]);
        const copyCategoryList = ref([]);

        const mergeLevel = (arr) => {
            // 合并相同类目id的父级
            const result = [];
            arr.forEach((item) => {
                const existingItem = result.find((existing) => existing.id === item.id);
                if (existingItem && item.children) {
                    item.children.forEach((child) => {
                        const existingChild = existingItem.children.find((c) => c.id === child.id);
                        if (existingChild?.children && existingChild.children?.length && child.children) {
                            existingChild.children = mergeLevel([...existingChild.children, ...child.children]);
                        } else if (!existingChild && child.children) {
                            existingItem.children.push(child);
                        }
                    });
                } else if (!existingItem && item.children) {
                    result.push(item);
                }
            });
            return result;
        };

        // 请求闪购后台类目
        const queryAllSgLeafBgCategory = async () => {
            const res = await hPost('/api/vss/shepherd/SgProductCommandTService/queryAllSgLeafBgCategory');
            copyCategoryList.value = res.sgBgCategories || [];

            const sgBgCategories = (res.sgBgCategories || []).map((item) => {
                const idArr = item.idPath.split(',').filter(Boolean);
                const labelArr = item.namePath.split(',').filter(Boolean);

                const children = [];
                const newItem = { id: +idArr[0], label: labelArr[0], children };
                let parent = newItem;
                for (let i = 0; i < idArr.length - 1; i++) {
                    const id = idArr[i + 1];
                    const label = labelArr[i + 1];
                    const child = parent.children.find((items) => items.id === id);
                    if (child) {
                        parent = child;
                    } else {
                        const newChild = { id: Number(id), label, children: [] };
                        parent.children.push(newChild);
                        parent = newChild;
                    }
                }
                return newItem;
            });
            sgCategoryList.value = mergeLevel(sgBgCategories);
        };

        // 定义一个方法，用于匹配闪购后台类目
        const mateSgCategory = (bgCategoryId) => (copyCategoryList.value || []).find((item) => item.id === bgCategoryId);

        const innerValue = computed({
            get() {
                return mateSgCategory(props.value)?.idPath.split(',').filter(Boolean).map((item) => Number(item));
            },
            set(val) {
                proxy.$emit('input', val[val.length - 1]);
            },
        });

        // 后台类目change
        const handleChange = (val) => {
            proxy.$emit('change', val[val.length - 1]);
        };

        queryAllSgLeafBgCategory();

        return {
            sgCategoryList,
            innerValue,
            queryAllSgLeafBgCategory,
            handleChange,
            mateSgCategory,
        };
    },
};
</script>


<style lang="scss" scoped>
    .cascader{
        width: 500px;
    }
</style>
